import React, { createContext, useContext, useState, useEffect } from 'react'
import ContactModal from '../components/ContactModal/ContactModal'
import { registerContactModal, ContactModalConfig } from '../utils/contactUtils'

interface ContactContextType {
  openContactForm: (config?: ContactModalConfig) => void
  closeContactForm: () => void
  isContactFormOpen: boolean
}

const ContactContext = createContext<ContactContextType | undefined>(undefined)

export const useContact = () => {
  const context = useContext(ContactContext)
  if (context === undefined) {
    throw new Error('useContact must be used within a ContactProvider')
  }
  return context
}

interface ContactProviderProps {
  children: React.ReactNode
}

const ContactProvider: React.FC<ContactProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [modalConfig, setModalConfig] = useState<ContactModalConfig>({})

  const openContactForm = (config: ContactModalConfig = {}) => {
    setModalConfig(config)
    setIsOpen(true)
  }

  const closeContactForm = () => {
    setIsOpen(false)
    // 清除配置，延迟执行避免动画问题
    setTimeout(() => {
      setModalConfig({})
    }, 300)
  }

  // 注册全局控制器
  useEffect(() => {
    registerContactModal({
      openModal: openContactForm,
      closeModal: closeContactForm
    })
  }, [])

  const contextValue: ContactContextType = {
    openContactForm,
    closeContactForm,
    isContactFormOpen: isOpen
  }

  return (
    <ContactContext.Provider value={contextValue}>
      {children}
      
      {/* 全局联系表单模态框 */}
      <ContactModal
        isOpen={isOpen}
        onClose={closeContactForm}
        initialSubject={modalConfig.subject}
        initialMessage={modalConfig.message}
        source={modalConfig.source}
      />
    </ContactContext.Provider>
  )
}

export default ContactProvider










